// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgn_a bhm_bi"};